import React from 'react'
import Nav from '../../Components/Nav/Nav';
import Footer from '../../Components/Footer/Footer';

function NotFoundScreen() {
    return (
        <>
            <Nav />
            <div className="NotFoundScreen">
                <p>This is the not found screen</p>
                <p></p>
            </div>
            <Footer />
        </>
    )
}

export default NotFoundScreen;
